import { Flex, Text, Box } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { BXInput, BXButton } from "@/styles";
import Countdown from "@/components/countdonw";
import { getEmialCodeApi, getPhoneCodeApi } from "@/api/common";
import { addSubAccountApi } from "@/api/subAccount";
import { geetestFlow } from "@/pages/resetAccountInfo/api";
import { throttle } from "lodash";
import { useAppSelector } from "@/state/hooks";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jsUuid } from "@/helpers/func/stringPro";

const Verify = ({
  emailBtnStatus,
  phoneBtnStatus,
  setEmailBtnStatus,
  setPhoneBtnStatus,
  CODE_BTN_STATUS,
  emailBtnDisabled,
  phoneBtnDisabled,
  setCurrStep,
  ADD_STEP,
  emailInput,
  pwdInput,
}) => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { userInfo } = useAppSelector((state) => state.user);
  const [phoneCode, setPhoneCode] = useState("");
  const [emailCode, setEmailCode] = useState("");

  const canSubmit = useMemo(() => {
    if (
      phoneCode &&
      emailCode &&
      phoneCode?.length === 6 &&
      emailCode?.length === 6
    ) {
      return true;
    }
    return false;
  }, [phoneCode, emailCode]);

  const renderCountDown = (type) => {
    return (
      <Countdown
        secondsInit="60"
        onTimeout={() => {
          if (type === "email") {
            setEmailBtnStatus(CODE_BTN_STATUS.RESNED);
          } else {
            setPhoneBtnStatus(CODE_BTN_STATUS.RESNED);
          }
        }}
      />
    );
  };

  const formateEmailInput = (email) => {
    if (!email) return;
    const flagIndex = email.indexOf("@");
    return email.slice(0, 3) + "******" + email.slice(flagIndex);
  };

  const formatePhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return;
    return "******" + phoneNumber.slice(-4);
  };

  const getEmailCodeFunc = throttle(async () => {
    const geetestFlowParams = {
      email: emailInput,
    };
    geetestFlow(geetestFlowParams, async () => {
      let scene;
      scene = "CREATE_SUB_USER";
      const res = await getEmialCodeApi({
        email: emailInput,
        scene,
      });
      if (res.code === 0) {
        setEmailBtnStatus(CODE_BTN_STATUS.COUNDDOWN);
      } else {
        setEmailBtnStatus(CODE_BTN_STATUS.RESNED);
      }
    });
  }, 5000);

  const getPhoneCodeFunc = throttle(async () => {
    const geetestFlowParams = {
      phone_code: userInfo?.phone_code,
      phone_number: userInfo?.phone_number,
      request_id: `CREATE_SUB_USER`,
    };
    geetestFlow(geetestFlowParams, async () => {
      const res = await getPhoneCodeApi({
        requestId: geetestFlowParams.request_id,
        phoneCode: userInfo.phone_code,
        phoneNumber: userInfo.phone_number,
      });
      if (res.code === 0) {
        setPhoneBtnStatus(CODE_BTN_STATUS.COUNDDOWN);
      } else {
        setPhoneBtnStatus(CODE_BTN_STATUS.RESNED);
      }
    });
  }, 5000);

  const addSubAccountFunc = async () => {
    const res = await addSubAccountApi({
      email: emailInput,
      login_password: pwdInput,
      email_code: emailCode,
      phone_code: phoneCode,
    });
    if (res.code === 0) {
      navigate("/trade/subAccount");
    }
  };

  return (
    <Flex
      alignItems={"center"}
      flexDirection={"column"}
      w={["90%", "500px"]}
      justifyContent={"flex-start"}
      margin={"0 auto"}
    >
      <Text fontSize={"24px"} fontWeight={600}>
        {t("fRcWTONIbiPEHREbRTKI")}
      </Text>

      <Box w={"100%"}>
        {/* 子账户邮箱 */}
        <Box mt={"40px"}>
          <Flex color={"#010313"} fontSize={"16px"} fontWeight={500}>
            <Text>{t("MIqinsTMANLFyEzWlLXm")}</Text>
            <Text ml={"5px"}>{formateEmailInput(emailInput)}</Text>
          </Flex>
          <Text mt={"20px"} fontSize={"14px"}>
            {t("OXrwZMwkWAjoSDDALzow")}
          </Text>
          <Flex
            justifyContent={"space-between"}
            w={"100%"}
            alignItems={"center"}
            mt={"10px"}
          >
            <BXInput
              placeholder={t("LuigfaXzmPRCftdFOV")}
              mt={"0px"}
              value={emailCode}
              onChange={(e) => setEmailCode(e.target.value)}
            />
            <BXButton
              w={"30%"}
              ml={"20px"}
              disabled={emailBtnDisabled}
              className={emailBtnDisabled ? "disabled" : ""}
              onClick={() => {
                if (!emailBtnDisabled) {
                  getEmailCodeFunc();
                }
              }}
            >
              {emailBtnStatus === CODE_BTN_STATUS.INIT &&
                t("wfUNVCtRXprhwYwce")}
              {emailBtnStatus === CODE_BTN_STATUS.COUNDDOWN && (
                <>{renderCountDown("email")}s</>
              )}
              {emailBtnStatus === CODE_BTN_STATUS.RESNED &&
                t("fxHeYqwgtTcKAdCKPyVe")}
            </BXButton>
          </Flex>
        </Box>
        {/* 手机号 */}
        <Box mt={"40px"}>
          <Flex color={"#010313"} fontSize={"16px"} fontWeight={500}>
            <Text>{t("razdiXXHIkQKbPQTZn")}:</Text>
            <Text ml={"5px"}>{formatePhoneNumber(userInfo.phone_number)}</Text>
          </Flex>
          <Text mt={"20px"} fontSize={"14px"}>
            {t("OXrwZMwkWAjoSDDALzow")}
          </Text>
          <Flex
            justifyContent={"space-between"}
            w={"100%"}
            alignItems={"center"}
            mt={"10px"}
          >
            <BXInput
              placeholder={t("LuigfaXzmPRCftdFOV")}
              mt={"0px"}
              value={phoneCode}
              onChange={(e) => setPhoneCode(e.target.value)}
            />
            <BXButton
              w={"30%"}
              ml={"20px"}
              value={phoneCode}
              disabled={phoneBtnDisabled}
              className={phoneBtnDisabled ? "disabled" : ""}
              onClick={() => {
                if (!phoneBtnDisabled) {
                  getPhoneCodeFunc();
                }
              }}
            >
              {phoneBtnStatus === CODE_BTN_STATUS.INIT &&
                t("wfUNVCtRXprhwYwce")}
              {phoneBtnStatus === CODE_BTN_STATUS.COUNDDOWN && (
                <>{renderCountDown("phone")}s</>
              )}
              {phoneBtnStatus === CODE_BTN_STATUS.RESNED &&
                t("fxHeYqwgtTcKAdCKPyVe")}
            </BXButton>
          </Flex>
        </Box>
      </Box>

      <Flex mt={"30px"} w={"80%"}>
        <BXButton
          className="cancel"
          w={"30%"}
          onClick={() => setCurrStep(ADD_STEP.CREATE)}
        >
          {t("WbPTckCFMKtPHgAlL")}
        </BXButton>
        <BXButton
          ml={"10px"}
          w={"70%"}
          className={!canSubmit ? "disabled" : ""}
          onClick={() => {
            if (canSubmit) {
              addSubAccountFunc();
            }
          }}
        >
          {t("AQrCocFqoKoYieUnT")}
        </BXButton>
      </Flex>
    </Flex>
  );
};

export default Verify;
